<!--部门下拉-->
<template>
  <el-cascader
    :options="branches"
    v-model="checkedBranch"
    :props="branchesProps"
    placeholder="请选择所属部门"
    clearable
    size="small"
    :collapse-tags="multiple"
    :style="multiple ? { width: '340px' } : {}"
  >
  </el-cascader>
</template>


<script>
import CommonService from "~/services/common";

export default {
  name: "UserCascader",
  props: {
    isBusiness: {
      type: Boolean,
      default: true
    },
    branch_id: {
      type: Number,
      default: 0
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uids: null,
      item: {
        label: "",
        value: "",
      },
      branches: [],
      branchesProps: {
        value: "id",
        label: "name",
        children: "childs",
        // expandTrigger: 'hover',
        checkStrictly: true,
        multiple: this.multiple
      },
      checkedBranch: [],
    };
  },

  created: function () {
    this.getBranches();
  },
  watch: {
    checkedBranch: function (value, original) {
      this.$emit("change", value);
    },
  },
  methods: {
    /**
     * 得到部门树状结构数据
     */
    getBranches() {
      CommonService.getAllBranches({'is_business': this.isBusiness}).then((res) => {
        if (res.code == 0 && res.data) {
          let branches = res.data;
          delete branches[0];
          this.branches = res.data;
          if(this.branch_id > 0){
            this.checkedBranch = this.findBranchPath(this.branch_id, this.branches);
            console.log('层级：', this.checkedBranch, this.branch_id);
          }
          
        }
      });
    },

    //对输入框进行重置
    reset() {
      this.checkedBranch = [];
      this.item = {
        label: "",
        value: "",
      };
      this.$emit("change", this.checkedBranch);
    },


    // 寻找包含 branch_id 的完整路径
    findBranchPath(branchId, branches) {
      for (const branch of branches) {
        // 检查是否为 null 或 undefined
        if (!branch) {
          continue;
        }
        // 打印调试信息
        // console.log(branchId, branch, branch.hasOwnProperty('childs') && branch.childs.length > 0, branch.id == branchId);
        // 如果找到匹配的 branch_id，则直接返回包含该 branch_id 的数组
        if (branch.id == branchId) {
          return [branch.id];
        }
        // 如果有子部门，并且子部门数量大于 0，则继续递归查找
        if (branch.hasOwnProperty('childs') && branch.childs.length > 0) {
          const childPath = this.findBranchPath(branchId, branch.childs);
          // 如果找到子部门中包含 branch_id 的路径，则在当前部门 id 前加入当前部门 id，并返回
          if (childPath.length > 0) {
            return [branch.id, ...childPath];
          }
        }
      }
      return [];
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/widgets/UserCascader.vue